import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxIndeterminate = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: "var(--checkbox-radius, 8)",
		fill: "var(--control-selected-bg, #79FBAF)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2727 12C16.2727 12.5523 15.825 13 15.2727 13H13.6198H9.65289H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9.65289H13.6198H15.2727C15.825 11 16.2727 11.4477 16.2727 12Z",
		fill: "var(--control-selected-mark, #0C5661)"
	})]
});
export default SvgCheckboxIndeterminate;
